import { ref } from '@nuxtjs/composition-api';
import { useApi } from '~/composables/useApi';
import trackMyOrderGql from './query/trackMyOrder.gql';

type orderResponse = {
    trackMyOrder: any[];
};

export function useTrackMyOrder() {
    const { query } = useApi();

    const useTrackOrder = async (queryVariables) => {
        const trackMyOrder = ref<any[]>([]);
        const loading = ref<boolean>(true);

        try {
            const response = await query<orderResponse>(trackMyOrderGql, queryVariables);
            trackMyOrder.value = response?.data?.trackMyOrder || [];
        } catch (error) {
            console.error('Error fetching trackMyOrder:', error);
        } finally {
            loading.value = false; // Set loading to false after fetching
        }

        return {
            trackMyOrder,
            loading,
        };
    }

    return { useTrackOrder };
}
export default useTrackMyOrder;